import { render, staticRenderFns } from "./FacturationDashboard.vue?vue&type=template&id=13e1cba1"
import script from "./FacturationDashboard.vue?vue&type=script&lang=ts"
export * from "./FacturationDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports